
jQuery(function ($) {

  let videoIndex = 0;
  const $playVideoButtParrent = $('.content-component__play-button').parent();
  const $playVideoBut = $('.content-component__play-button');
  const $embedVideoContainer = $('.content-component__embed-container');
  const $overlayVideoDiv = $('.overlayEmbedVideoDiv');
  const $closeVideoBut = $('.close-video-button-overlay');
  const $header = $('header');
  const $overlayAnimationDiv = $('.overlayAnimationVideoDiv');

  function loadVideoStuff(e) {
    e.preventDefault();
    $embedVideoContainer.css('display', 'flex');
    $overlayAnimationDiv.css('display', 'flex');
    $overlayAnimationDiv.css('animation-name', 'fadeIn');
    $overlayVideoDiv.show();
    $header.hide();
    $playVideoBut.hide();
    $('body').css('overflow', 'hidden');
    window.setTimeout(function () {
      $overlayAnimationDiv.css('z-index', '1');
    }, 5000);
  }

  function closeVideoStuff() {
    $playVideoBut.show();
    $header.show();
    $overlayAnimationDiv.css('display', 'none');
    $embedVideoContainer.css('display', 'none');
    $overlayVideoDiv.hide();
    $('body').css('overflow', 'auto');
    $overlayAnimationDiv.css('z-index', '44');
  }

  /**
   * Video component is dynamic component, we can't know how many component will be on the page
   * This function set data-attribute to element
   * Data attribute will be index of that element
   * @param {} element 
   */
  function setDataAttributeToElements(element) {
    element.map((i, el) => {
      el.setAttribute('data-item', i);
    })
  }
  function setClassName(element, className) {
    element.addClass(function (index) {
      return className + index;
    });
  }

  setClassName($('iframe'), 'embed-')
  setClassName($playVideoButtParrent, 'connect-to-embed-')
  setClassName($closeVideoBut, 'close-embed-')
  setDataAttributeToElements($playVideoBut)

  //On click play button autoplay video from youtube
  $playVideoBut.on('click', function (e) {
    console.log('sssss')
    videoIndex = e.target.getAttribute('data-item')
    e.preventDefault();
    $("iframe").hide();
    $(`iframe.embed-${videoIndex}`).show();
    $(`iframe.embed-${videoIndex}`)[0].src += "&autoplay=1";
    loadVideoStuff(e);

  });

  //On close
  $closeVideoBut.on('click', function (e) {
    let videoSrc = $(`iframe.embed-${videoIndex}`).attr('src');
    videoSrc = videoSrc.replace("&autoplay=1", '');
    $(`iframe.embed-${videoIndex}`).attr('src', videoSrc);
    closeVideoStuff();
  });
});

